import moment from 'moment';
import { unitOfTime } from 'moment';
import { LeaseTermUnits } from './lease.model';

export const DURATION_CATALOG: { [key: string]: unitOfTime.Base } = {
  [LeaseTermUnits.Days]: 'days',
  [LeaseTermUnits.Years]: 'years',
  [LeaseTermUnits.Months]: 'months',
  [LeaseTermUnits.Unknown]: 'months',
};

const getUnitOfTime = (uomValue: string) => DURATION_CATALOG[uomValue ?? LeaseTermUnits.Months];

export class LeaseCommandsHelper {
  public static CalcLeaseTerm(term: { startDate: Date; endDate: Date; uom: string }): number {
    const UTC_EDP_INPUT_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
    const { startDate, endDate, uom } = term;

    if (startDate != null && endDate != null) {
      const startDateMoment = moment(startDate, UTC_EDP_INPUT_FORMAT);
      const endDateMoment = moment(endDate, UTC_EDP_INPUT_FORMAT);

      if (!startDateMoment.isValid() || !endDateMoment.isValid()) {
        return;
      }

      const newTermDiff = endDateMoment.diff(startDateMoment, getUnitOfTime(uom), true);
      return Math.round(newTermDiff);
    }
  }
}
